import { Pipe, PipeTransform } from '@angular/core';
import { NotificationItem } from '../../api/models';

@Pipe({
  name: 'notificationColor'
})
export class NotificationColorPipe implements PipeTransform {

  transform(value: NotificationItem, ...args: unknown[]): string {
    let cssClassMap: Map<number, string> = new Map([
      [1, "alert"],
      [2, "reminder"],
      [3, "user"],
      [4, "community"],
      [5, "success"],
    ])
    return (cssClassMap.get(value?.id)) || 'alert';
  }

}